/**
 * Module dependencies.
 */

import { ModelRangeFilter } from 'src/types/model-ranges';
import {
  QueryObserverBaseResult,
  QueryObserverOptions,
  useQuery
} from 'react-query';
import { fetchModelRangeFilters } from './fetch-model-range-filters';
import { useMemo } from 'react';
import { useRouter } from 'next/router';

/**
 * `Result` type.
 */

type Result = QueryObserverBaseResult<ModelRangeFilter[], unknown>;

/**
 * `Options` type.
 */

type Options = QueryObserverOptions<ModelRangeFilter[]>;

/**
 * Action type.
 */

const actionType = ({ locale }): string => {
  return `${locale}-model-range-filters`;
};

/**
 * `useModelRangeFilters` hook.
 */

function useModelRangeFilters(options?: Options): Result {
  const { locale } = useRouter();
  const variables = useMemo(() => ({ locale }), [locale]);
  const result = useQuery(
    [actionType(variables), variables],
    () => {
      return fetchModelRangeFilters(variables);
    },
    options
  );

  return result;
}

/**
 * Export `useModelRangeFilters` hook.
 */

export default useModelRangeFilters;
